"use client";
import React from "react";
import PropTypes from "prop-types";
// local component imports
import Widget from "./Widget";
import LottieLoader from "../../../components/atoms/lottieLoader";
import { isLcpNamedWidget } from "../../../utils/dynamicHomeUtils/lcpWidget";

/**
 */
const Feed = ({ widgets, isMobile, isCampaignLoading }) => {
  return (
    <>
      {isCampaignLoading && !isMobile && (
        <LottieLoader isShowLottie={false} position="fixed" zIndex="z-[999]" backdropBlur="15px" />
      )}

      {widgets?.map((feedItem, index) => {
        if (feedItem == null || typeof feedItem !== "object") return null;
        const { order, widget, tracking: feedTracking } = feedItem;
        if (!widget) return null;
        const isLcpWidget = isLcpNamedWidget(widget);

        return (
          <Widget
            isMobile={isMobile}
            key={order ?? index}
            order={order ?? index + 1}
            widget={widget}
            tracking={feedTracking ?? widget?.tracking}
            isAboveFold={isLcpWidget}
            isLcpCandidate={isLcpWidget}
          />
        );
      })}
    </>
  );
};

Feed.propTypes = {
  widgets: PropTypes.arrayOf(
    PropTypes.shape({
      order: PropTypes.number,
      widget: PropTypes.object,
    }),
  ).isRequired,
  isMobile: PropTypes.bool.isRequired,
  isCampaignLoading: PropTypes.bool.isRequired,
};

export default Feed;
